(function ($, undefined) {

    'use strict';
    var formValidator;
    var checkbox;
    var extraRadio;
    var submitMentorFormBtn;

    var addCheckboxes = function () {
        var t = $(this);
        var form = t.closest('.js-form');
        var input = form.find('.checkbox-field');

        if (t.prop('checked') === true) {
            input.val(input.val() + t.val() + ', ');
        } else {
            input.val(input.val().replace(t.val() + ', ', ''));
        }
    };

    var addExtraRadio = function () {
        var t = $(this);
        var form = t.closest('.js-form');
        var input = form.find('.field-extra-checkbox');

        input.val(t.val());
    };

    var submitMentorForm = function () {
        var t = $(this);
        var form = t.closest('.js-form');
        var successMsg = form.find('.mentoring-form-sent');

        successMsg.slideUp();
        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            var multipart = form.hasClass("js-multipart-form");
            var formdata = new FormData(form[0]);

            var count = t.attr('data-count');
            var email = form.find('input[name=email]').val();
            var subject = form.find('input[name=subject]').val();
            var content = form.find('textarea[name=content]').val();
            var type = t.attr('data-id');
            var url = '/action/pmiMentorat';

            if (multipart) {
                formdata.append('count', count);
                formdata.append('email', email);
                formdata.append('targetEmail', '');
                formdata.append('type', type);
                formdata.append('subject', subject);
                formdata.append('content', content);

                for (var i = 1; i < count; i++) {
                    if ($('.field' + i, form).length !== 0) {
                        formdata.append('fieldName' + i, $('.fieldName' + i, form).val());
                        formdata.append('field' + i, $('.field' + i, form).val());
                    }
                }
                
                $.ajax({
                    method: 'post',
                    type: 'post',
                    url: url,
                    data: formdata,
                    cache: false,
                    contentType: false,
                    processData: false,
                    success: function (res) {
                        _success(res);
                    }
                });
            } else {
                url += '?subject=' + encodeURIComponent(subject);
                url += '&type=' + type;

                for (var i = 1; i < count; i++) {
                    if ($('.field' + i, form).length !== 0) {
                        url += '&fieldName' + i + '=' + encodeURIComponent($('.fieldName' + i, form).val());
                        url += '&field' + i + '=' + encodeURIComponent($('.field' + i, form).val());
                    }
                }
                url += '&count=' + count + '&targetEmail=' + '&email=' + email + '&content=' + content;

                ajax(url, function (response) {
                    _success(response);
                }, true);
            }

        }
        
        var _success = function (response) {
            if (response.indexOf('success') !== -1) {
                form.find('input[type=checkbox]:checked').prop('checked', false);
                form.find('input[type=radio]:checked').prop('checked', false);
                form.find('input:not([type=checkbox]), textarea').removeClass('has-value').removeClass('success').val('');
                form.find('.success-fields-hide').slideUp();
                t.hide();
                successMsg.slideDown();
            }
        };
    };

    var init = function () {
        formValidator = Fw.component.models().form;
        checkbox = $('input[name=mentorship-type]');
        extraRadio = $('input[name=mentorship-radio-extra]');
        submitMentorFormBtn = $('.submit-mentor-form-btn');

        checkbox.click(addCheckboxes);
        extraRadio.click(addExtraRadio);
        submitMentorFormBtn.click(submitMentorForm);

    };

    $(window).ready(function () {
        init();
    });

})(jQuery);

